import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { LoggerType } from '@app/core/enums/logger-type.enum';
import { LeakScoreStatus } from '@app/core/enums/leak-score-status.enum';
import { LeakDetectionMode } from '@app/core/enums/leak-detection-mode.enum';
import { getLoggerMarkerIcon, LoggerMarkerIconProperty } from '@app/main/main-content/map/config/logger-marker-icon';
import { LoggerMarkerMode } from '@app/main/main-content/map/enums/logger-marker-mode.enum';
import { MarkerAbbreviation } from '@app/main/main-content/map/enums/marker-abbreviation.enum';
import { LdLoggerNoiseScoreLeakComponent } from '@app/main/leak-detection/components/ld-helper/ld-logger-noise-score-leak/ld-logger-noise-score-leak.component';
import { LdLoggerNoiseScoreAiPredictorComponent } from '@app/main/leak-detection/components/ld-helper/ld-logger-noise-score-ai-predictor/ld-logger-noise-score-ai-predictor.component';

@Component({
  selector: 'gc-ld-logger-noise-type-icon-with-score',
  standalone: true,
  imports: [NgClass, SvgIconComponent, LdLoggerNoiseScoreLeakComponent, LdLoggerNoiseScoreAiPredictorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-type-icon-with-score.component.html',
})
export class LdLoggerNoiseTypeIconWithScoreComponent {
  public loggerType = input.required<LoggerType>();
  public leakScore = input<number | undefined>();
  public leakScoreStatus = input<LeakScoreStatus | undefined>();
  public leakDetectionMode = input<LeakDetectionMode>(LeakDetectionMode.LeakScore);
  public small = input<boolean>(false);

  public isAiPredictor = computed(() => this.leakDetectionMode() === LeakDetectionMode.LeakAiPredictor);

  public markerIcon = computed(() => {
    const loggerType = this.loggerType();
    const status = this.leakScoreStatus() ?? LeakScoreStatus.Neutral;

    return {
      src: getLoggerMarkerIcon(
        LoggerMarkerMode.Default,
        loggerType,
        status,
        MarkerAbbreviation.True,
        LoggerMarkerIconProperty.Src
      ),
      name: getLoggerMarkerIcon(
        LoggerMarkerMode.Default,
        loggerType,
        status,
        MarkerAbbreviation.True,
        LoggerMarkerIconProperty.Name
      ),
    };
  });
}
